var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Model } from 'vue-property-decorator';
import DataBox from '~/components/common/data-box.vue';
import FlieUpload from '~/components/common/file-upload.vue';
import { PrincipalService } from "~/services/domain-service/principal.service";
import { Dependencies } from "~/core/decorator";
var AddAccount = /** @class */ (function (_super) {
    __extends(AddAccount, _super);
    function AddAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.relationData = [];
        _this.show = false;
        _this.imgUrl = '';
        return _this;
    }
    AddAccount.prototype.onClickShow = function (row) {
        this.imgUrl = row.fileList[0].response.url;
    };
    AddAccount.prototype.deleteClick = function (scope) {
        var _this = this;
        if (scope.row.id) {
            this.principalService.deleteReceivAccountById(scope.row.id).subscribe(function (data) {
                _this.expressionDataSet.splice(scope.$index, 1);
            }, function (_a) {
                var msg = _a.msg;
            });
        }
        else {
            this.expressionDataSet.splice(scope.$index, 1);
        }
    };
    __decorate([
        Model('change')
    ], AddAccount.prototype, "expressionDataSet", void 0);
    __decorate([
        Dependencies(PrincipalService)
    ], AddAccount.prototype, "principalService", void 0);
    AddAccount = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                FlieUpload: FlieUpload
            }
        })
    ], AddAccount);
    return AddAccount;
}(Vue));
export default AddAccount;
